<template>
  <div>
    <el-alert show-icon type="info1" title="Please Note" description="Any updated sites will only disappear on refresh." />
    <xolas-table
      ref="sitesWithoutLandowners"
      table-ref="sitesWithoutLandownersDataTable"

      title="Sites Without Landowners"
      icon="fa fa-user-slash"

      url="report/property/without/landlords"
      :fields="fields"

      layer-component="siteTenancy"
      :layer-args="{ id: 'id' }"
      search-placeholder="Site Status, Site Names, Site Groups...">
    </xolas-table>
  </div>
</template>


<script>

import DateMixins from '@/mixins/DateMixins'

export default {

  mixins: [DateMixins],

  data () {
    return {

      // All data columns use a proportional `minWidth` so el-table spreads the
      // available width across them (rather than dumping all slack on Site Name,
      // which left the date/status columns clustered at the far right with a big
      // gap). `#` stays a fixed narrow column; Site Name is widest. Verified live
      // with the report's ~69 rows (XOL-346) — columns fill the width evenly.
      fields: [
        {
          name: '__sequence',
          title: '#',
          width: 36,
          sortField: 'site_id'
        },
        {
          title: 'Status',
          name: 'status',
          minWidth: 90,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: !this.status || this.siteGroup
        },
        {
          title: 'Site Group',
          name: 'siteGroup',
          minWidth: 120,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          title: 'Site Name',
          name: 'siteName',
          minWidth: 300
        },
        {
          title: 'Handover',
          name: 'handover',
          minWidth: 120,
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          title: 'Tenancy Status',
          name: 'landStatus',
          minWidth: 130
        },
        {
          title: 'Tenancy Type',
          name: 'landType',
          minWidth: 120
        }
      ]
    }
  }
}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
